import api from './axios';

export const bookingsAPI = {
  createBooking: async (data, { idempotencyKey } = {}) => {
    // Pin one key per submission attempt so retries (network blip, double-click)
    // collapse to the same booking. The form usually pins a key in data.idempotencyKey;
    // honour that, otherwise honour the second-arg override, otherwise mint one.
    const key =
      idempotencyKey ||
      data?.idempotencyKey ||
      (typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : `bk_${Date.now()}_${Math.random().toString(36).slice(2)}`);
    const response = await api.post('/bookings', data, {
      headers: { 'Idempotency-Key': key },
    });
    return response.data;
  },

  getBookings: async (params = {}, { silent = false } = {}) => {
    try {
      const response = await api.get('/bookings', { params, silent });
      return response.data;
    } catch (error) {
      if (!silent) throw error;
      return { bookings: [] };
    }
  },

  getBooking: async (id) => {
    const response = await api.get(`/bookings/${id}`);
    return response.data;
  },

  confirmBooking: async (id, providerId) => {
    const url = providerId ? `/bookings/${id}/confirm?providerId=${providerId}` : `/bookings/${id}/confirm`;
    const response = await api.post(url);
    return response.data;
  },

  declineBooking: async (id, reason, providerId) => {
    const url = providerId ? `/bookings/${id}/decline?providerId=${providerId}` : `/bookings/${id}/decline`;
    const response = await api.post(url, { reason });
    return response.data;
  },

  cancelBooking: async (id, data) => {
    const response = await api.post(`/bookings/${id}/cancel`, data);
    return response.data;
  },

  rescheduleBooking: async (id, data) => {
    const response = await api.post(`/bookings/${id}/reschedule`, data);
    return response.data;
  },

  completeBooking: async (id, providerId) => {
    const url = providerId ? `/bookings/${id}/complete?providerId=${providerId}` : `/bookings/${id}/complete`;
    const response = await api.post(url);
    return response.data;
  },

  markNoShow: async (id) => {
    const response = await api.post(`/bookings/${id}/no-show`);
    return response.data;
  },
};
